export default "__VITE_ASSET__BzpYRine__"